import React from "react";
import Grid from '@material-ui/core/Grid';
import Fab from '@material-ui/core/Fab';
import Typography from '@material-ui/core/Typography';

const Button = ({onClick, children}) => {
  return (
    <Fab size="medium" color="primary" aria-label="Add" variant="extended" onClick={onClick}>
      <Grid container justify="space-between" alignItems="center">
        <Typography color="inherit" >
          {children}
        </Typography>
      </Grid>
    </Fab>
  );
};

export default Button;
